// extracted by mini-css-extract-plugin
module.exports = {"productPastContainer":"az_WHb","fulfillmentOptions":"az_XHb","fullWidthinMobile":"az_YHb"};